<script>
	export default {
	  name: 'mu-radio',
	  props: {
	    value: {
	      type: [Number, String]
	    },
	    nativeValue: {
	      type: [Number, String]
	    }
	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/mixins/MuRadio.vue